import { useEffect } from "react";
import { createPortal } from "react-dom";
import { getAppPortalRoot } from "../utils/appPortal";
import { X } from "lucide-react";
import "./DeleteWordModal.css";

export default function NotesConfirmModal({
  open = false,
  title = "Modifications non enregistrées",
  message = "",
  confirmLabel = "Continuer",
  cancelLabel = "Annuler",
  onConfirm = () => {},
  onCancel = () => {},
}) {
  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onCancel();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [open, onCancel]);

  if (!open) return null;

  return createPortal(
    <div
      className="delete-word-modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onCancel();
      }}
    >
      <div
        className="delete-word-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="notes-confirm-modal-title"
      >
        <button
          type="button"
          className="delete-word-modal__close"
          onClick={onCancel}
          aria-label="Fermer"
        >
          <X size={18} strokeWidth={2.5} />
        </button>

        <h3 id="notes-confirm-modal-title" className="delete-word-modal__title">
          {title}
        </h3>
        <p className="delete-word-modal__text">{message}</p>

        <div className="delete-word-modal__actions">
          <button
            type="button"
            className="delete-word-modal__btn delete-word-modal__btn--cancel"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="delete-word-modal__btn delete-word-modal__btn--confirm"
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    getAppPortalRoot()
  );
}
